import { DeleteConfirmPopup } from '../../../../common/DeleteConfirmPopup/DeleteConfirmPopup';
import { translate } from '../../../../common/helpers/translate.helper';
import { useAuthenticationMethodDelete } from '../../hooks/useAuthenticationMethodDelete';
import { MfaAccessControl } from '../../hooks/useMfaAccessControl';

interface RemoveMfaConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    methodId?: string;
    accessControl: MfaAccessControl;
    userId: string;
}

export const RemoveMfaConfirmationModal = ({
    isOpen,
    onClose,
    methodId,
    accessControl,
    userId,
}: RemoveMfaConfirmationModalProps) => {
    const deleteMethodMutation = useAuthenticationMethodDelete(accessControl.isSuperAdminViewingOthers, userId);

    const handleDelete = async () => {
        if (!methodId) return;

        try {
            await deleteMethodMutation.mutateAsync({ authenticationMethodId: methodId });
        } finally {
            onClose();
        }
    };

    return (
        <DeleteConfirmPopup
            isOpen={isOpen}
            onSubmit={handleDelete}
            onDismiss={onClose}
            headline={translate('mfa.delete.title')}
            text={translate('mfa.delete.message')}
            deleteButtonText={translate('mfa.delete.btn.remove')}
            itemToDelete={translate('mfa.delete.method')}
            isSubmitting={deleteMethodMutation.isPending}
        />
    );
};
